import { render, staticRenderFns } from "./VerDetalleListaDistribucionModal.vue?vue&type=template&id=ede54b18&"
import script from "./VerDetalleListaDistribucionModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleListaDistribucionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports